/**
 * @method: to call reducer
 */
import { actionType } from "../auth/action";
import defaultState from '../../store/defaultStore';
let defaultStore = defaultState;
const reducer = (state = defaultStore, action) => {

     switch (action.type) {
          case actionType.LOGIN_AUTH_REQUEST:
               state = { ...state, ...defaultState };
               break;
          case actionType.LOGIN_AUTH_SUCCESS:
               defaultState.auth = {...defaultState.auth, ...action.payload};
               state = { ...state, ...defaultState }
               
               break;
          case actionType.LOGIN_AUTH_FAILURE:
               defaultState.auth = action.payload;
               state = { ...state, ...defaultState }
               break;

          default:
               state = { ...state };
               break;
     }

     return state;
};
export default reducer;